import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Select, DatePicker } from 'antd';
import { startOfDay, endOfDay, isBefore } from 'date-fns';

import { getTranslatedString } from 'helpers/i18n';

const StyledFieldContainer = styled.div`
  width: ${(props) => (props.isMobile ? '100%' : '49%')};
  margin-top: ${(props) => (props.isMobile ? '16px' : '0px')};
`;

const StyledSelect = styled(Select)`
  margin-top: 8px;
  width: 100%;
`;

const StyledDatePicker = styled(DatePicker)`
  margin-top: 8px;
  width: 100%;

  input {
    font-size: 14px !important;
    font-family: Circular, sans-serif;
  }
`;

const SiteField = ({ isMobile, value, onChange, loading, availableSites }) => {
  return (
    <StyledFieldContainer isMobile={isMobile}>
      <div>{getTranslatedString('site')}</div>
      <StyledSelect
        value={value}
        showSearch
        placeholder={getTranslatedString(
          'landlordPortal.applicationManagement.inviteLeadToApply.selectASite'
        )}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={onChange}
        loading={loading}
        size={isMobile && 'large'}
      >
        {availableSites.map((site) => (
          <Select.Option value={site.id} key={`site_${site.id}}`}>
            {site.label}
          </Select.Option>
        ))}
      </StyledSelect>
    </StyledFieldContainer>
  );
};

SiteField.propTypes = {
  isMobile: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  availableSites: PropTypes.array,
};

const PropertyField = ({ isMobile, value, onChange, loading, availableProperties }) => {
  return (
    <StyledFieldContainer isMobile={isMobile}>
      <div>{getTranslatedString('property')}</div>
      <StyledSelect
        value={value}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={onChange}
        loading={loading}
        size={isMobile && 'large'}
      >
        {availableProperties.map((property) => (
          <Select.Option value={property.id} key={`property_${property.id}}`}>
            {property.label}
          </Select.Option>
        ))}
      </StyledSelect>
    </StyledFieldContainer>
  );
};

PropertyField.propTypes = {
  isMobile: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  availableProperties: PropTypes.array,
};

const LeaseStartDateField = ({ isMobile, value, onChange }) => {
  const disabledLeaseStartDate = (date) => {
    const startDate = endOfDay(new Date(date));
    const isLeaseStartDateInThePast = isBefore(startDate, startOfDay(new Date()));

    return isLeaseStartDateInThePast;
  };

  return (
    <StyledFieldContainer isMobile={isMobile}>
      <div>
        {getTranslatedString(
          'landlordPortal.applicationManagement.inviteLeadToApply.additionalInformation.leaseDates.leaseStartDate'
        )}
      </div>
      <StyledDatePicker
        size={isMobile && 'large'}
        value={value}
        onChange={onChange}
        disabledDate={disabledLeaseStartDate}
        className="ant-form-item-control-input" // hack to avoid date-picker with font-size 16px
      />
    </StyledFieldContainer>
  );
};

LeaseStartDateField.propTypes = {
  isMobile: PropTypes.bool,
  value: PropTypes.object,
  onChange: PropTypes.func,
};

const GroupField = ({ isMobile, value, onChange }) => {
  return (
    <StyledFieldContainer isMobile={isMobile}>
      <div>
        {getTranslatedString('landlordPortal.applicationManagement.inviteLeadToApply.group')}
      </div>
      <StyledSelect
        value={value}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={onChange}
        size={isMobile && 'large'}
      >
        {[].map((item) => (
          <Select.Option value={item.id} key={`item_${item.id}}`}>
            {item.label}
          </Select.Option>
        ))}
      </StyledSelect>
    </StyledFieldContainer>
  );
};

GroupField.propTypes = {
  isMobile: PropTypes.bool,
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export { PropertyField, SiteField, LeaseStartDateField, GroupField };
